import React from "react";
import HeaderBanner from "../../Components/HeaderBanner/HeaderBanner";
import illustration from "../../Media/illustration.png";

export default function CollectionsPage() {
  return (
    <div>
      <HeaderBanner title="Collection" currentPath="Collections" />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh"
        }}
      >
        <img style={{height: 400}} src={illustration} alt="Not available" />
      </div>
    </div>
  );
}
